"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
var react_1 = __importDefault(require("react"));
var components_1 = require("../components");
var Customize_1 = require("./Customize");
var FontSize_1 = require("./FontSize");
var FontStyle_1 = require("./FontStyle");
var Text = function () { return (react_1.default.createElement(components_1.Doc, { title: "Text" },
    react_1.default.createElement(FontSize_1.FontSize, null),
    react_1.default.createElement(FontStyle_1.FontStyle, null),
    react_1.default.createElement(Customize_1.TextCustomize, null))); };
exports.Text = Text;
